var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sweet-modal",
    {
      ref: "blockUserModal",
      attrs: { icon: "warning" },
      on: {
        close: function($event) {
          return _vm.$emit("modal-close")
        }
      }
    },
    [
      _vm.selected !== null
        ? _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("p", {
                staticClass: "mt-3",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("pages.admin.users.block_confirmation", {
                      first_name: _vm.selected.first_name,
                      last_name: _vm.selected.last_name
                    })
                  )
                }
              }),
              _vm._v(" "),
              _c("block-confirmation", { on: { clicked: _vm.blockUser } }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("actions.block")) +
                    "\n        "
                )
              ])
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }